import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SellersPage from './pages/SellersPage';
import ReportsPage from './pages/ReportsPage';
import DisputesPage from './pages/DisputesPage';
import PaymentsPage from './pages/PaymentsPage';
import ShipmentsPage from './pages/ShipmentsPage';
import WalletsPage from './pages/WalletsPage';
import CallbacksPage from './pages/CallbacksPage';
import ServerPage from './pages/ServerPage';
import UsersPage from './pages/UsersPage';
import SchoolShopsPage from './pages/SchoolShopsPage';
import BroadcastPage from './pages/BroadcastPage';
import SchoolsPage from './pages/SchoolsPage';
import Layout from './components/Layout';

function App() {
  // Simple auth check, replace with a more robust solution
  const isAuthenticated = () => localStorage.getItem('adminToken') !== null;

  const PrivateRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to="/login" />;
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route 
          path="/*"
          element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/sellers" element={<SellersPage />} />
                  <Route path="/users" element={<UsersPage />} />
                  <Route path="/users/:id" element={<UsersPage />} />
                  <Route path="/school-shops" element={<SchoolShopsPage />} />
                  <Route path="/schools" element={<SchoolsPage />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/admin-users" element={<Navigate to="/users" replace />} />
                  <Route path="/disputes" element={<DisputesPage />} />
                  <Route path="/payments" element={<PaymentsPage />} />
                  <Route path="/shipments" element={<ShipmentsPage />} />
                  <Route path="/wallets" element={<WalletsPage />} />
                  <Route path="/broadcast" element={<BroadcastPage />} />
                  <Route path="/callbacks" element={<CallbacksPage />} />
                  <Route path="/server" element={<ServerPage />} />
                  <Route path="/" element={<Navigate to="/dashboard" />} />
                </Routes>
              </Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
